const pageFlipperWidthPercent = 0.13;
const minPageFlipperWidth = 30;

export const getPageFlipperWidth = (containerWidth: number) =>
  Math.max(containerWidth * pageFlipperWidthPercent, minPageFlipperWidth);
